import type { PropsWithChildren } from 'react';
import React, { createContext, useContext } from 'react';

export type MenuPreviewContextValue = {
  designPanelPreviewStateMap?: Record<string, string>;
};

export const MenuPreviewContext = createContext<MenuPreviewContextValue>({
  designPanelPreviewStateMap: {},
});

export const useMenuPreviewContext = () => useContext(MenuPreviewContext);

export const MenuPreviewContextProvider: React.FC<
  PropsWithChildren<MenuPreviewContextValue>
> = ({ children, designPanelPreviewStateMap }) => {
  return (
    <MenuPreviewContext.Provider value={{ designPanelPreviewStateMap }}>
      {children}
    </MenuPreviewContext.Provider>
  );
};
